import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { createRoot } from 'react-dom/client'
import './assets/scss/index.scss'
import App from './App'

// MSAL Setup
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { msalConfig } from "./msalConfig"

const msalInstance = new PublicClientApplication(msalConfig);

function index() {
  return (
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Router>
          <App />
        </Router>
      </MsalProvider>
    </React.StrictMode>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(index())
